module.exports = __webpack_public_path__ + "static/media/27a.18b0934f.jpg";